import type { AppStrings } from './types.js';
import { plural } from './plural.js';

export const ptPT: AppStrings = {
  // COMMON
  error_title: 'Erro',
  cancel: 'Cancelar',
  retry: 'Tentar novamente',
  back_arrow: '← Voltar',

  // ASK SCREEN
  ask_box_unavailable: 'Box indisponível',
  ask_box_unavailable_desc: 'O link pode estar desatualizado ou o dono fechou o box.',
  ask_create_own_box: 'Criar o meu próprio box',
  ask_sent_title: 'Enviado ✅',
  ask_sent_desc: 'A tua pergunta anónima foi entregue ao dono do box.',
  ask_anonymous_hint: 'A tua pergunta será enviada de forma anónima.',
  ask_placeholder: 'Escreve a tua pergunta…',
  ask_send: 'Enviar',
  ask_sending: 'A enviar…',
  ask_error_rate_limit: 'Demasiados pedidos — aguarda um momento.',
  ask_error_restart: 'Por favor, reinicia a Mini App.',
  ask_error_load: 'Não foi possível carregar o box.',
  ask_error_send: 'Não foi possível enviar a pergunta.',
  ask_error_banned: 'Estás bloqueado na app.',
  ask_banned_appeal_btn: 'Recorrer',
  ask_appeal_sent: 'Recurso enviado. Vamos analisá-lo manualmente.',

  // AGE GATE
  age_gate_title: 'Apenas maiores de 18',
  age_gate_desc:
    'Estás a enviar uma pergunta anónima. Sê respeitoso: assédio, ameaças, conteúdo sexual que envolva menores e qualquer conteúdo ilegal são proibidos. O anonimato não implica impunidade — as infracções são reportadas à moderação. Ao enviar uma pergunta, confirmas que tens 18+ e aceitas as regras.',
  age_gate_confirm: 'Tenho 18+ — continuar',

  // INBOX SCREEN
  inbox_title: 'O teu box',
  box_link_accordion: 'Link de convite',
  inbox_notifications_ask: '🔔 Permitir que o bot envie notificações sobre novas perguntas?',
  inbox_notifications_allow: 'Permitir',
  inbox_notifications_dismiss_label: 'Ignorar',
  inbox_box_toggle_disable: 'Desativar perguntas',
  inbox_box_toggle_enable: 'Ativar perguntas',
  inbox_box_disabled_warning: 'Perguntas desativadas — não serão aceites novas perguntas.',
  inbox_share_hint: 'Partilha o link para que os teus amigos te façam perguntas anónimas.',
  inbox_copy: 'Copiar',
  inbox_copied: 'Copiado',
  inbox_copy_error: 'Erro',
  inbox_no_deeplink: 'O link aparecerá após o deploy.',
  inbox_invite_story: 'Convidar via Story',
  inbox_invite_chat: 'Convidar via chat',
  inbox_card_rendering: 'O cartão de convite ainda está a ser gerado.',
  inbox_story_unsupported:
    'As Stories não estão disponíveis nesta versão do Telegram. Tenta "via chat".',
  inbox_story_error: 'Não foi possível abrir a Story.',
  inbox_chat_unsupported:
    'A partilha via chat não está disponível nesta versão do Telegram. Atualiza o teu cliente.',
  inbox_chat_error: 'Não foi possível partilhar. Tenta novamente.',
  inbox_chat_prepare_error: 'Não foi possível preparar o convite.',
  inbox_filter_incoming: 'Recebidas',
  inbox_filter_hidden: 'Ocultas',
  inbox_filter_blocked: 'Bloqueadas',
  inbox_filter_empty: 'Ainda nada aqui.',
  inbox_acc_unanswered: 'Sem resposta',
  inbox_acc_answered: 'Respondidas',
  inbox_acc_hidden: 'Ocultas',
  inbox_acc_blocked: 'Bloqueadas',
  inbox_empty: 'Ainda sem perguntas. Partilha o link acima.',
  inbox_load_more: 'Carregar mais',
  inbox_load_more_error: 'Não foi possível carregar a página seguinte.',
  inbox_error_load: 'Não foi possível carregar o box.',
  inbox_rate_limit: 'Demasiados pedidos — aguarda um momento.',
  inbox_toggle_error: 'Não foi possível alterar o estado do box.',

  // MESSAGE BOX (Трек D)
  message_tagline: 'Escreve-me anonimamente',
  message_placeholder: 'Escreve uma mensagem…',
  message_anonymous_hint: 'A tua mensagem será enviada de forma anónima.',
  message_sent_title: 'Enviado ✅',
  message_sent_desc: 'A tua mensagem anónima foi entregue.',
  message_owner_entry: 'Escreve-me',
  message_share_hint: 'Partilha o link para que qualquer pessoa te possa enviar uma mensagem anónima.',
  message_inbox_open: 'Mensagens recebidas',
  message_inbox_title: 'Mensagens',
  message_inbox_empty: 'Ainda sem mensagens. Partilha o teu link acima.',

  // ANSWER SCREEN
  answer_title: 'Responder à pergunta',
  answer_placeholder: 'Escreve a tua resposta…',
  answer_submit: 'Enviar',
  answer_submitting: 'A enviar…',
  answer_back: 'Voltar',
  answer_error_send: 'Não foi possível enviar a resposta.',

  // SHARE SCREEN
  share_title: 'Resposta publicada ✅',
  share_hint: 'Partilha o cartão e recebe ainda mais perguntas.',
  share_card_rendering_desc:
    'O cartão ainda está a ser gerado. Volta às perguntas e verifica em breve — poderás partilhá-lo numa Story ou via chat.',
  share_card_alt: 'Cartão de resposta',
  share_story_btn: 'Partilhar na Story',
  share_story_btn_busy: 'A abrir…',
  share_chat_btn: 'Partilhar no chat',
  share_chat_btn_busy: 'A preparar…',
  share_back: 'Voltar às perguntas',
  share_story_unsupported:
    'As Stories não estão disponíveis nesta versão do Telegram. Tenta "Partilhar no chat".',
  share_story_error: 'Não foi possível abrir a Story. Tenta "Partilhar no chat".',
  share_chat_sent: 'Mensagem enviada.',
  share_chat_unsupported:
    'A partilha via chat não está disponível nesta versão do Telegram. Atualiza o teu cliente.',
  share_chat_error: 'Não foi possível partilhar. Tenta novamente.',
  share_chat_prepare_error: 'Não foi possível preparar a mensagem.',

  // LEADERBOARD SCREEN
  lb_title: 'Classificação',
  lb_period_7d: '7 dias',
  lb_period_30d: '30 dias',
  lb_period_all: 'Desde sempre',
  lb_group_label: 'Categoria',
  lb_group_all: 'Todos',
  lb_group_ask: 'Perguntas',
  lb_group_rate: 'Avaliações',
  lb_group_confession: 'Confissões',
  lb_group_guesswho: 'Adivinha quem',
  lb_group_message: 'Mensagens',
  lb_error: 'Não foi possível carregar a classificação',
  lb_empty: 'Ainda ninguém na classificação',
  lb_anon: 'Anónimo',
  lb_load_more: 'Carregar mais',
  lb_questions: (n) => plural('pt-pt', n, { one: '{n} pergunta', other: '{n} perguntas' }),
  lb_referrals: (n) => plural('pt-pt', n, { one: '{n} ref.', other: '{n} refs.' }),

  // REWARDS SCREEN
  rw_title: 'As minhas recompensas',
  rw_error: 'Não foi possível carregar as recompensas',
  rw_level: (n) => `Nível ${n}`,
  rw_confirmed_referrals: (n) =>
    plural('pt-pt', n, { one: '{n} referido confirmado', other: '{n} referidos confirmados' }),
  rw_next_level_section: (n) =>
    plural('pt-pt', n, { one: 'PRÓXIMO NÍVEL — {n} referido', other: 'PRÓXIMO NÍVEL — {n} referidos' }),
  rw_to_level: (level, target) => `para o nível ${level}: ${target}`,
  rw_max_level: 'Nível máximo atingido!',
  rw_badges_section: 'CONQUISTAS',
  rw_formats_section: 'FORMATOS DE BOX',

  // QUESTION CARD
  qcard_status_new: 'Nova',
  qcard_status_hidden: 'Oculta',
  qcard_status_answered: 'Respondida',
  qcard_moderation_flagged: 'Atenção: mensagem suspeita',
  qcard_answer_btn: 'Responder',
  qcard_answer_send: 'Enviar',
  qcard_share_btn: 'Partilhar',
  qcard_hide_btn: 'Ocultar',
  qcard_show_btn: 'Mostrar',
  qcard_report_btn: 'Denunciar',
  qcard_block_btn: 'Bloquear',
  qcard_unblock_btn: 'Desbloquear',
  qcard_report_reason_label: 'Seleciona o motivo da denúncia:',
  qcard_reason_spam: 'Spam',
  qcard_reason_harassment: 'Assédio',
  qcard_reason_sexual: 'Conteúdo sexual',
  qcard_reason_other: 'Outro',
  qcard_error_hide: 'Não foi possível alterar a visibilidade.',
  qcard_error_report: 'Não foi possível enviar a denúncia.',
  qcard_error_block: 'Não foi possível bloquear o remetente.',
  qcard_report_done: 'Denúncia enviada — obrigado.',
  qcard_block_done: 'Remetente bloqueado.',
  qcard_unblock_done: 'Remetente desbloqueado.',

  // ERRORS
  err_network: 'Sem ligação ao servidor. Verifica a tua ligação à internet e tenta novamente.',
  err_server_unavailable: 'O servidor está temporariamente indisponível, tenta novamente mais tarde.',
  err_internal: 'Algo correu mal da nossa parte. Já estamos a verificar — tenta novamente mais tarde.',
  err_bad_request: 'Por favor, verifica os dados que introduziste.',
  err_generic: 'Não foi possível concluir a ação, tenta novamente mais tarde.',
  err_schema: 'Erro nos dados. Tenta atualizar a app.',
  share_story_link_premium_note:
    'Um link clicável nas Stories requer o Telegram Premium. Sem ele, os teus amigos ainda te podem encontrar — o teu nome de utilizador é apresentado no cartão.',

  // AUTH ERROR SCREEN
  auth_error_title: 'Erro de acesso',
  auth_error_desc:
    'Falha na autenticação. Fecha e volta a abrir a Mini App a partir do Telegram.',

  // REWARD TOAST
  reward_toast_title: 'Nova recompensa!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: 'Perguntas',
  tab_leaderboard: 'Classificação',
  tab_rewards: 'Recompensas',
  tab_settings: 'Definições',

  // SETTINGS SCREEN
  settings_title: 'Definições',
  settings_section_general: 'Geral',
  settings_notifications: 'Notificações de novas perguntas',
  settings_notifications_hint: 'O bot vai avisar-te quando alguém te fizer uma pergunta.',
  settings_notifications_error: 'Não foi possível guardar a configuração de notificação.',
  settings_language: 'Idioma',
  settings_language_error: 'Não foi possível alterar o idioma. Tenta novamente.',
  settings_section_about: 'Sobre',
  settings_version: 'Versão',

  // CODE ENTRY (work-020)
  code_modal_title: 'Links nas Stories são exclusivos para Premium',
  code_modal_explain:
    'O Telegram só fornece um link clicável nas Stories aos subscritores Premium. Em alternativa, adiciona o teu código à story — os visitantes introduzem-no na app e fazem-te uma pergunta anónima.',
  code_modal_your_code: 'O teu código',
  code_modal_copy: 'Copiar código',
  code_modal_copied: 'Copiado',
  code_modal_share_btn: 'Partilhar na story',
  code_modal_loading: 'A obter o teu código…',
  code_modal_error: 'Não foi possível obter o teu código. Tenta mais tarde.',
  ask_code_title: 'Introduz um código',
  ask_code_desc:
    'Vieste de uma story? Encontra o código nela (ex. 1234) e introduz-o abaixo.',
  ask_code_placeholder: 'Código da story',
  ask_code_find: 'Procurar',
  ask_code_not_found: 'Código não encontrado. Verifica os dígitos e tenta novamente.',
  ask_code_invalid: 'O código tem 4 dígitos.',
  code_onboarding_header: 'Vieste de uma story?',
  code_onboarding_text: 'Introduz o código de um amigo para lhe fazer uma pergunta anónima.',
  code_onboarding_action: 'Introduzir código',
  settings_ask_by_code: 'Perguntar por código',
  settings_my_code_title: 'O teu código para stories',
  settings_my_code_hint:
    'Escreve este código na tua story — os visitantes introduzem-no para te fazer uma pergunta anónima. O Telegram reserva os links clicáveis nas Stories aos subscritores Premium.',
  settings_my_code_rotate: 'Obter novo código',
  settings_my_code_rotating: 'A atualizar…',
  settings_my_code_done: 'Código atualizado',
  settings_my_code_error: 'Não foi possível obter o teu código.',
  settings_my_code_rotate_confirm_title: 'Mudar o código?',
  settings_my_code_rotate_confirm_desc:
    'O teu código antigo deixa de funcionar de imediato. Quem o viu na tua story deixa de conseguir contactar-te. Muda-o só se alguém te estiver a fazer spam.',
  settings_my_code_rotate_confirm_action: 'Mudar código',

  // BOT
  bot_greeting: (name) => (name ? `Olá, ${name}! 👋` : 'Olá! 👋'),
  bot_onboarding:
    'Isto é o VeylMe — perguntas anónimas.\n\n' +
    'Abre a Mini App, publica um card «Pergunta-me anonimamente» na tua Story — ' +
    'e recebe perguntas anónimas diretamente aqui.\n\n' +
    '⚠️ 18+. Sê respeitoso: bullying, ameaças e conteúdo proibido ' +
    'não são permitidos. Anonimato ≠ impunidade — as infrações vão para moderação.',
  bot_open_btn: 'Abrir VeylMe',
  notify_answer_btn: 'Responder',
  bot_invite_text:
    'Alguém partilhou um link do VeylMe.\n\n' +
    'Abre a Mini App para fazer uma pergunta anónima:',
  bot_invite_btn: 'Perguntar anonimamente',

  // WORK-027 i18n sweep
  tagline: 'Pergunta-me anonimamente',
  share_ask_action: 'Perguntar',
  share_answered_text: 'Respondi a uma pergunta anónima 👀',
  err_not_in_telegram: 'A Mini App não está a ser executada no Telegram. Reinicia a app.',
  badge_viral_starter: 'Início viral',
  badge_storyteller: 'Contador de histórias',
  badge_loop_master: 'Mestre do ciclo',
  theme_confession: 'Confissões',
  theme_guesswho: 'Adivinha quem',
  rw_format_named: (name) => `formato «${name}»`,
  card_label_question: 'Pergunta',
  card_label_answer: 'Resposta',
  card_invite_subtitle: 'anónimo, sem registo',
  card_code_hint: 'INTRODUZ O CÓDIGO NA APP',
  share_msg_title: (brand) => `${brand} · Perguntas anónimas`,
  notify_new_question: '🔔 Alguém fez-te uma pergunta anónima',
  notify_unanswered_reminder: (n) =>
    plural('pt-pt', n, { one: '🔔 Tens {n} pergunta por responder', other: '🔔 Tens {n} perguntas por responder' }),
  notify_ban_permanent: 'permanentemente',
  notify_ban_until: (date) => `até ${date}`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ Estás bloqueado no VeylMe ${untilPhrase}. Demasiados destinatários denunciaram as tuas mensagens.\nSe achares que isto é um engano, podes submeter um recurso na app.`,
  notify_warning_msg:
    '⚠️ Vários destinatários denunciaram as tuas mensagens. Mais um pouco e serás bloqueado no VeylMe.',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: 'As minhas perguntas',
  my_questions_empty_title: 'Ainda não fizeste nenhuma pergunta',
  my_questions_empty_desc: 'Faz uma pergunta na caixa de alguém — a resposta vai aparecer aqui.',
  my_questions_loading: 'A verificar a resposta…',
  my_questions_waiting: 'À espera de resposta',
  my_questions_answer_label: 'Resposta',
  settings_my_questions: 'As minhas perguntas',
  ask_sent_find_reply_hint: 'Poderás encontrar a resposta mais tarde em «As minhas perguntas».',
  inbox_story_nonpremium_hint: 'Uma ligação de Story não é clicável sem Telegram Premium, por isso mostramos um código — partilhar no chat é mais fiável.',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'O teu acesso do Telegram expirou',
  session_expired_desc: 'O Telegram dá o acesso à app apenas uma vez, ao abrir, e este já expirou. Abre a app de novo — guardámos o texto que começaste.',
  session_expired_desc_no_storage: 'O teu acesso ao Telegram expirou e é preciso reabrir a app. Não conseguimos guardar o texto que escreveste — copia-o antes de sair.',
  session_expired_reopen: 'Abrir de novo',
  session_expired_stuck_title: 'O Telegram devolveu o mesmo acesso antigo',
  session_expired_stuck_desc: 'Fecha a app por completo pelo menu do bot e abre-a de novo — assim o Telegram dará um acesso novo.',
  session_auth_failed_title: 'Não foi possível confirmar a tua entrada',
  session_auth_failed_desc: 'O Telegram não confirmou a tua entrada na app. Fecha a app e abre-a de novo pelo chat com o bot.',
  session_expired_manual_close: 'A app não se consegue fechar sozinha aqui — fecha-a tu e abre-a de novo pelo chat com o bot.',
  session_expiring_soon: 'O teu acesso do Telegram vai expirar em breve. Abre a app de novo para não perderes nada.',
  my_questions_check_failed: 'Não foi possível verificar as respostas. Tenta mais tarde.',
  settings_notifications_load_error: 'Não foi possível carregar a definição.',
};
